import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-environmental-benefits',
    imports: [TranslateModule],
    templateUrl: './environmental-benefits.component.html',
    styleUrl: './environmental-benefits.component.scss'
})
export class EnvironmentalBenefitsComponent {
 @Input () equivalentTreesPlanted!:number|string;
 @Input() co2EmissionSaved!:string;
 @Input() coalNotBurned!:string|number;
}
